import app from 'flarum/forum/app';
import { normalizeBattlePassLevels, battlePassMaxLevel, battlePassLevelForGames } from '../common/battlePass';

/**
 * Forum-side accessors over the two public Battle Pass forum attributes
 * (see the Settings extender in extend.php). Everything is derived
 * client-side from games played — the backend only stores the "already
 * rewarded up to" high-water mark, which the UI never needs.
 */

export function battlePassConfig() {
  const enabled = app.forum.attribute('arenaBattlePassEnabled') === true;
  const levels = normalizeBattlePassLevels(app.forum.attribute('arenaBattlePassLevels'));
  const gamesPerLevel = Math.max(1, Number(app.forum.attribute('arenaBattlePassGamesPerLevel')) || 1);
  return {
    // The master switch (admin toggle, default off) gates every Battle
    // Pass surface, even with levels configured.
    configured: enabled && levels.size > 0,
    gamesPerLevel,
    levels,
    maxLevel: battlePassMaxLevel(levels)
  };
}

/** wins + losses + draws from the public arenaStats attribute. */
export function battlePassGamesPlayed(user) {
  const stats = user?.attribute('arenaStats');
  if (!stats) return 0;
  return (stats.wins ?? 0) + (stats.losses ?? 0) + (stats.draws ?? 0);
}
export function battlePassLevelFor(user, config) {
  if (config === void 0) {
    config = battlePassConfig();
  }
  return battlePassLevelForGames(battlePassGamesPlayed(user), config.gamesPerLevel, config.maxLevel);
}
/** Everything the progress line ("8 из 10 игр до 8 уровня") needs, shared
 *  by BattlePassBar's header and BattlePassModal's centered badge. */
export function battlePassProgress(games, config) {
  if (config === void 0) {
    config = battlePassConfig();
  }
  const safeGames = Math.max(0, games || 0);
  const current = battlePassLevelForGames(safeGames, config.gamesPerLevel, config.maxLevel);
  const isMax = current >= config.maxLevel;
  return {
    games: safeGames,
    current,
    intoLevel: isMax ? 0 : safeGames - (current - 1) * config.gamesPerLevel,
    needed: config.gamesPerLevel,
    next: current + 1,
    isMax
  };
}
export function battlePassProgressText(progress) {
  return progress.isMax ? app.translator.trans('forumaker-arena.forum.battle_pass.max_level_reached') : app.translator.trans('forumaker-arena.forum.battle_pass.progress', {
    current: String(progress.intoLevel),
    needed: String(progress.needed),
    next: String(progress.next)
  });
}